import {putUserInfo, saveUserData} from "./user";
import {getOut} from "../Utils/Common";

/**
 * Check if the last admin or the last super-admin is going
 * to be deactivate
 */
export function checkValidation(mystate) {
        let createcopy = mystate.editUserData;
        let fResult = createcopy.items["fn"] !== "" &&
            createcopy.items["ln"] !== "" &&
            createcopy.items["em"] !== "" &&
            createcopy.items["co"] !== "" &&
            (mystate.userGender.length !== 0) && (mystate.errorMessageGender === "") &&
            (mystate.errorMessageEMail === "") && (mystate.errorMessageContactNumber === "") &&
            (mystate.errorMessageRole === "") && (mystate.userRoles.length !== 0) &&
            (mystate.errorMessageFirstName === "") && (mystate.errorMessageLastName === "");
        //&& (mystate.businessRoles.length !==0)
        let sResult = true;
        if (!mystate.displayStatus && mystate.loggedInUser === 'superAdmin') {
            sResult = (mystate.userCompanyName.length !== 0) && (mystate.errorMessageCompany === "");
        }
        return fResult && sResult

    }

 /**
 * Make an api call to
  * update an existing user's detail
  * or to create a new user detail
 */
export async function handleUserSave(mystate, changeState, case_nr) {
    let validationError = checkValidation(mystate);
     if (!("business_role" in mystate.editUserData.items)) {
         mystate.editUserData.items.business_role = {"8abb4736-e4a1-4df3-b7f6-cdb1736e80c4": "Default"}
     }
    if (validationError === false) {
        alert("Das Formular ist ungültig. Bitte füllen Sie alle Angaben aus.")
    } else {
        if (mystate.displayStatus === false) {
            let createcopy = mystate.editUserData;
            createcopy.items["st"] = true;
            changeState({editUserData: createcopy})
        }
        changeState({editUserModalShow: false});
        if (case_nr === 0) {
            let rsl = await putUserInfo(JSON.parse(JSON.stringify(mystate.editUserData.items)));
            if (rsl.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
                getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
            }

            if (rsl.newrole === `${process.env.REACT_APP_BACKEND_MSGCHANGEDROLE}`) {
                sessionStorage.setItem('roles', JSON.stringify(rsl.newrole_list));
                location.href = "/";
            }
            else {
                setTimeout(function () {
                    window.location.reload(0.5);
                }, 500);
            }
        } else {
            //let res = await saveUserData(mystate.editUserData.items).then(response => console.log('response is ' + response));
            let res = await saveUserData(mystate.editUserData.items);
            if ((JSON.stringify(res)).message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
                getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
            }
            setTimeout(function () {
                window.location.reload(0.5);
            }, 500);
        }
    }
}